import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { TextVideo2_Carlos } from '../../../../../utils/ES/Modals/directors';

const ModalVideoCarlos2 = () => {
  return (
    <>
      <ModalVideo
        id="carlos-video-2"
        dataText={TextVideo2_Carlos}
        videoSrc="https://player.vimeo.com/video/536065938?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_DIRECTORS_CARLOS_2"
      />
    </>
  );
};

export default ModalVideoCarlos2;
